@import "../../common/css/variable.css";
@import "./input.soild.scss";

:host {
  fill: currentColor;
  --placeholder-color: initial;
  --placeholder-font-style: initial;
  --placeholder-font-weight: initial;
  --placeholder-opacity: 0.6;

  --border-radius: 0px;
  --padding-top: 0px;
  --padding-end: 0px;
  --padding-bottom: 0px;
  --padding-start: 0px;

  --background: transparent;
  --color: initial;
  --border-style: solid;
  --highlight-color-focused: #404040;
  --highlight-color-valid: #404040;
  --highlight-color-invalid: var(--danger-color);
  --highlight-color: var(--highlight-color-focused);
  --border-width: 1px;
  --border-color: var(--border-base-color);

  display: block;
  position: relative;
  width: 100%;
  padding: 0 !important;
  color: var(--color);
  z-index: 2;
  min-height: 45px;
}

:host-context(jackery-item:not(.item-label):not(.item-has-modern-input)) {
  --padding-start: 0;
}

:host-context(jackery-item)[slot="start"],
:host-context(jackery-item)[slot="end"] {
  width: auto;
}

// Input Fill: Outline
// ----------------------------------------------------------------

:host(.input-fill-outline) {
  --border-color: #b3b3b3;
  --border-radius: 4px;
  --padding-start: 16px;
  --padding-end: 16px;
}

:host(.input-fill-outline.input-shape-round) {
  --border-radius: 28px;
  --padding-start: 32px;
  --padding-end: 32px;
}
:host(.input-fill-outline.input-shape-round) {
  --border-radius: 28px;
  --padding-start: 32px;
  --padding-end: 32px;
}

:host(.has-focus.input-fill-outline.jackery-valid),
:host(.input-fill-outline.jackery-invalid) {
  --border-color: var(--highlight-color);
}
 
@media (any-hover: hover) {
  :host(.input-fill-outline:hover) {
    --border-color: #404040;
  }
}

:host(.input-fill-outline.has-focus) {
  --border-width: 2px;
  --border-color: var(--highlight-color);
}

:host(.input-fill-solid.has-focus) .input-wrapper {
  border-bottom: 2px solid var(--highlight-color);
}

:host(.input-fill-outline.has-focus) .label-text-wrapper {
  background: #fff;
}


/* Native Input */
// --------------------------------------------------
.native-input {
  padding: 0;
  display: inline-block;
  position: relative;
  flex: 1;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  border: 0!important;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  appearance: none;
  z-index: 1;
  &::placeholder {
    opacity: 0.8;
    color: var(--text-placeholder-color);
  }
  &:-webkit-autofill {
    background-color: transparent;
  }
  &:invalid {
    box-shadow: none;
  }
  &::-ms-clear {
    display: none;
  }
}

// Clear Input Icon
// --------------------------------------------------
.input-clear-icon {
  margin: auto;
  padding: 0;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  outline: none;
  background-color: transparent;
  background-repeat: no-repeat;
  color: #666666;
  visibility: hidden;
  appearance: none;
  cursor: pointer;
}
.input-clear-icon .clear-icon {
  width: 20px;
  height: 20px;
}
:host(.in-item-color) .input-clear-icon {
  color: inherit;
}
.input-clear-icon:focus {
  opacity: 0.5;
}
:host(.has-value) .input-clear-icon {
  visibility: visible;
}

// Input Has focus
// --------------------------------------------------
// When the input has focus, then the input cover should be hidden
:host(.has-focus) {
  pointer-events: none;
}

:host(.has-focus) input,
:host(.has-focus) a,
:host(.has-focus) button {
  pointer-events: auto;
}

// Item Floating: Placeholder
// ----------------------------------------------------------------
// 当label设置floating时 placeholder 需隐藏
:host-context(.item-label-floating.item-has-placeholder:not(.item-has-value)) {
  opacity: 0;
}

:host-context(.item-label-floating.item-has-placeholder:not(.item-has-value).item-has-focus) {
  transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
}

// Input Wrapper
// ----------------------------------------------------------------
.input-wrapper {
  padding: var(--padding-top) var(--padding-end) var(--padding-bottom) var(--padding-start);
  border-radius: var(--border-radius);
  display: flex;
  position: relative;
  flex-grow: 1;
  align-items: stretch;
  height: inherit;
  min-height: inherit;
  transition: background-color 15ms linear;
  background: var(--background);
  line-height: normal;
}

:host(.input-fill-solid) .input-wrapper {
  padding-bottom: 4px;
}

// Input Native Wrapper
// ----------------------------------------------------------------
.native-wrapper {
  display: flex;
  position: relative;
  flex-grow: 1;
  width: 100%;
}

// 有错误显示的情况
:host([error-text]) {
  position: relative;
  padding-bottom: 16px!important;
}
:host(.jackery-touched.jackery-invalid) {
  --highlight-color: var(--highlight-color-invalid);
}
:host(.jackery-invalid) {
  --highlight-color: var(--highlight-color-invalid);
}

/**
 * highlight: 只有focus状态下显示.
 */
:host(.jackery-valid) {
  --highlight-color: var(--highlight-color-valid);
}

// Input Bottom Content
// ----------------------------------------------------------------
.input-bottom {
  // 底部提示文案 - 与lebel对齐
  padding-top: 5px var(--padding-end) 0 var(--padding-start);
  display: flex;
  justify-content: space-between;
  border-top: var(--border-width) var(--border-style) var(--border-color);
  font-size: 12px;
}

:host(.has-focus.jackery-valid),
:host(.jackery-touched.jackery-invalid) {
  --border-color: var(--highlight-color);
}

// Input Hint Text
// ----------------------------------------------------------------
/**
 * Error text 只在 .ion-invalid 上显示， 否则显示helper text
 */
 .input-bottom .error-text {
  display: none;
  color: var(--highlight-color-invalid);
  position: absolute;
  bottom: 0;
  left: 0;
}

.input-bottom .helper-text {
  display: block;
  color: var(--text-secondary-color);
}

:host(.jackery-invalid) .input-bottom .error-text {
  display: block;
}

:host(.jackery-invalid) .input-bottom .helper-text {
  display: none;
}

// Input Max Length Counter - 字符计数器
// ----------------------------------------------------------------
.input-bottom .counter {
  margin-inline-start: auto;
  color: #949494;
  white-space: nowrap;
  padding-inline-start: 16px;
}

// Input Native
// ----------------------------------------------------------------
:host(.has-focus) input {
  caret-color: var(--border-primary-color);
}

// Input Label
// ----------------------------------------------------------------
.label-text-wrapper {
  display: flex;
  align-items: center;
  max-width: 200px;
  transition: color 150ms cubic-bezier(.4, 0, .2, 1), transform 150ms cubic-bezier(.4, 0, .2, 1);
  pointer-events: none;
}

.label-text,
::slotted([slot="label"]) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: var(--font-base);
  color: var(--text-secondary-color);
}

.label-text-wrapper-hidden,
.input-outline-notch-hidden {
  display: none;
}

.input-wrapper input {
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
  font-size: var(--font-base);
  color: var(--text-main-color);
}

// Input Label Placement - start
// ----------------------------------------------------------------
:host(.input-label-placement-start) .input-wrapper {
  flex-direction: row;
}

:host(.input-label-placement-start) .label-text-wrapper {
  margin: 0 16px 0 0;
}

// Input Label Placement - End
// ----------------------------------------------------------------
 :host(.input-label-placement-end) .input-wrapper {
  flex-direction: row-reverse;
}

:host(.input-label-placement-end) .input-wrapper {
  flex-direction: row-reverse;
}

:host(.input-label-placement-end) .label-text-wrapper {
  margin: 0 0 0 16px;
}

// Input Label Placement - fixed
// ----------------------------------------------------------------
:host(.input-label-placement-fixed) .label-text-wrapper {
  margin: 0 16px 0 0;
}

:host(.input-label-placement-fixed) .label-text {
  flex: 0 0 100px;
  width: 100px;
  min-width: 100px;
  max-width: 200px;
}

:host(.input-label-placement-stacked) .input-wrapper,
:host(.input-label-placement-floating) .input-wrapper {
  flex-direction: column;
  align-items: start;
}

:host(.input-label-placement-stacked) .label-text-wrapper,
:host(.input-label-placement-floating) .label-text-wrapper {
  transform-origin: left top;
  max-width: 100%;
  z-index: 2;
}

:host(.input-label-placement-stacked) input,
:host(.input-label-placement-floating) input {
  // margin: 1px 0 0 0;
  margin: 8px 0 0 0;
}

// Input Label Placement - floating
// ----------------------------------------------------------------
:host(.input-label-placement-floating) .label-text-wrapper {
  transform: translateY(100%) scale(1);
}

:host(.input-label-placement-floating) input {
  opacity: 0;
}

:host(.has-focus.input-label-placement-floating) input,
:host(.has-value.input-label-placement-floating) input {
  opacity: 1;
}

/**
 * floating or stacked：当input focus时候label高亮
 */
 :host(.input-label-placement-floating.has-focus) .label-text-wrapper .label-text,
 :host(.input-label-placement-stacked.has-focus) .label-text-wrapper .label-text {
   color: var(--highlight-color);
 }

// lable移动到上方动画
:host(.input-label-placement-stacked) .label-text-wrapper,
:host(.has-focus.input-label-placement-floating) .label-text-wrapper,
:host(.has-value.input-label-placement-floating) .label-text-wrapper {
  transform: translateY(50%) scale(0.75);
  max-width: calc(100% / 0.75);
}



// Input Fill: Outline
// ----------------------------------------------------------------
:host(.input-fill-outline) .input-bottom {
  border-top: none;
}

:host(.input-fill-outline) .input-wrapper {
  border-bottom: none;
}

:host(.input-fill-outline.input-label-placement-stacked) .label-text-wrapper,
:host(.input-fill-outline.input-label-placement-floating) .label-text-wrapper {
  transform-origin: left top;
  position: absolute;
  max-width: calc(100% - var(--padding-start) - var(--padding-end));
  transform: translateY(calc(50% + 3px)) scale(1);
}

:host(.input-fill-outline) .label-text-wrapper,
:host(.input-fill-outline) .label-text-wrapper {
  position: relative;
}

:host(.has-focus.input-fill-outline.input-label-placement-floating) .label-text-wrapper,
:host(.has-value.input-fill-outline.input-label-placement-floating) .label-text-wrapper,
:host(.input-fill-outline.input-label-placement-stacked) .label-text-wrapper {
  transform-origin: left top;
  margin: 0;
  max-width: calc(100% - var(--padding-start) - var(--padding-end));
  transform: translateY(-50%) scale(0.75);
  background: #fff;
}

:host(.input-fill-outline.input-label-placement-stacked) input,
:host(.input-fill-outline.input-label-placement-floating) input {
  margin: 6px 0;
}

:host(.input-fill-outline) .input-outline-container {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
}

:host(.input-fill-outline) .input-outline-start,
:host(.input-fill-outline) .input-outline-end {
  pointer-events: none;
}

:host(.input-fill-outline) .input-outline-start,
:host(.input-fill-outline) .input-outline-notch,
:host(.input-fill-outline) .input-outline-end {
  border-top: var(--border-width) var(--border-style) var(--border-color);
  border-bottom: var(--border-width) var(--border-style) var(--border-color);
}

:host(.input-fill-outline) .input-outline-notch {
  max-width: calc(100% - var(--padding-start) - var(--padding-end));
}

:host(.input-fill-outline) .notch-spacer {
  padding: 0 4px 4px 0;
  font-size: calc(1em * 0.75);
  opacity: 0;
  pointer-events: none;
  box-sizing: content-box;
}

:host(.input-fill-outline) .input-outline-start {
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: var(--border-radius);
  width: 12px;
  border: var(--border-width) var(--border-style) var(--border-color);
  border-right: none;
}

:host(.input-fill-outline) .input-outline-end {
  border: var(--border-width) var(--border-style) var(--border-color);
  border-left: none;
  border-top-left-radius: 0px;
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  border-bottom-left-radius: 0px;
  flex-grow: 1;
}

:host(.has-focus.input-fill-outline.input-label-placement-floating) .input-outline-notch,
:host(.has-value.input-fill-outline.input-label-placement-floating) .input-outline-notch,
:host(.input-fill-outline.input-label-placement-stacked) .input-outline-notch {
  border-top: none;
}